export default __webpack_public_path__ + "static/media/photo--lg--hockey7.08a064bb.jpg";